import { render, staticRenderFns } from "./LeftNews.vue?vue&type=template&id=6e607600&scoped=true&"
import script from "./LeftNews.vue?vue&type=script&lang=js&"
export * from "./LeftNews.vue?vue&type=script&lang=js&"
import style0 from "./LeftNews.vue?vue&type=style&index=0&id=6e607600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e607600",
  null
  
)

export default component.exports